import type { RouteLocationNormalized } from 'vue-router'
import { defineNuxtRouteMiddleware, navigateTo } from '#app'
import { useUrlSetup } from '~/shared/composables/useUrlSetup'

export default defineNuxtRouteMiddleware((to: RouteLocationNormalized) => {
  const { cleanLocation } = useUrlSetup(to)

  if (cleanLocation != null) {
    return navigateTo(cleanLocation, { replace: true })
  }
})
